module.exports = __webpack_public_path__ + "static/media/bg.91ddea22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg.png
// module id = 499
// module chunks = 0